
import React, { useEffect } from 'react';

import Table from "./partials/Table";
import FilterForm from "./partials/FilterForm";

export default () => {

  useEffect(() => {
    document.title = "Kỳ quay Max3D"
  }, []);

  return (
    <>
      <FilterForm />
      <br />
      <Table />
    </>
  );
};
